import { useState } from 'react';
import useMentorSuggestedSearch from './useMentorSuggestedSearch';
const usePeopleSearch = ({
  getTotal,
  getList,
  useInfiniteQueryPeople,
  peopleSearchOptions = {},
  useFindSuggestedMentor,
  studentId,
  hasRoleMentor
}) => {
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(null);
  const {
    isLoading,
    isSuccess,
    fetchStatus,
    status,
    isFetchingMore,
    data,
    canFetchMore,
    fetchMore
  } = useInfiniteQueryPeople(query, peopleSearchOptions);
  const peopleList = getList(data || []);
  const total = getTotal(data || []);
  const hasEmptyPeopleList = isSuccess && query === '' && total === 0;

  // istanbul ignore next
  if (hasRoleMentor) {
    return useMentorSuggestedSearch({
      useFindSuggestedMentor,
      studentId
    });
  }
  return {
    status,
    fetchStatus,
    query,
    hasEmptyPeopleList,
    onQueryChange: setQuery,
    selected,
    onSelect: setSelected,
    isLoading,
    isFetchingMore,
    peopleList,
    total,
    canFetchMore,
    shouldFetchOnMount: peopleSearchOptions.shouldFetchOnMount,
    onLoadMore: () => fetchMore()
  };
};
export default usePeopleSearch;